import * as React from 'react'
import { useEffect, useState } from 'react'
import ClipLoader from 'react-spinners/ClipLoader'
import toastr from 'toastr'
import Button from '../../components/Button'
import { ProfanityAPI } from '../../api/endpoints'
import { ProfanityWord } from '../../api/models/profanityWord'

export const Profanity: React.FC = () => {
    const [words, setWords] = useState<ProfanityWord[]>([])
    const [loading, setLoading] = useState(true)
    const [newWord, setNewWord] = useState('')
    const [adding, setAdding] = useState(false)

    useEffect(() => {
        load()
    }, [])

    const load = () => {
        setLoading(true)
        ProfanityAPI.getWords()
            .then((res) => setWords(res))
            .catch(() => toastr.error('Wörter konnten nicht geladen werden'))
            .finally(() => setLoading(false))
    }

    const add = () => {
        const w = newWord.trim()
        if (w.length < 2) {
            toastr.warning('Bitte gib mindestens ein Wort mit mindestens 2 Zeichen ein')
            return
        }
        setAdding(true)
        ProfanityAPI.addWords(w)
            .then((res) => {
                setNewWord('')
                if (res.added.length > 0) {
                    toastr.success(`${res.added.length} Wort/Wörter hinzugefügt${res.skipped.length ? `, ${res.skipped.length} bereits vorhanden` : ''}`)
                } else {
                    toastr.info('Keine neuen Wörter – alle bereits vorhanden')
                }
                load()
            })
            .catch(() => toastr.error('Wörter konnten nicht hinzugefügt werden'))
            .finally(() => setAdding(false))
    }

    const remove = (id: string) => {
        ProfanityAPI.deleteWord(id)
            .then(() => {
                toastr.success('Wort entfernt')
                setWords((prev) => prev.filter((w) => w.id !== id))
            })
            .catch(() => toastr.error('Wort konnte nicht entfernt werden'))
    }

    if (loading) {
        return <div style={{ display: 'flex', flex: 1, justifyContent: 'center', alignItems: 'center' }}>
            <ClipLoader />
        </div>
    }

    return (
        <div className="main">
            <div className="row">
                <div className="col-12">
                    <div className="news_add_card">
                        <p>Wörter zur Sperrliste hinzufügen (einzeln oder kommagetrennt)</p>
                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start' }}>
                            <textarea
                                value={newWord}
                                rows={2}
                                placeholder="z.B. penis, arsch, geier"
                                onChange={(e) => setNewWord(e.target.value)}
                                style={{ padding: 8, flex: 1, marginRight: 8 }}
                            />
                            <div style={{ width: 160 }}>
                                <Button text="Hinzufügen" onClick={() => add()} loading={adding} disabled={adding} className="primary" />
                            </div>
                        </div>
                        <p style={{ marginTop: 12, opacity: .7, fontSize: 13 }}>
                            {`${words.length} gesperrte Wörter. Trenne mehrere Wörter mit Komma, Semikolon oder Zeilenumbruch. Die Erkennung greift auch bei Abwandlungen (z.B. "MrPenis", "p3n1s", "peeenis").`}
                        </p>
                    </div>
                </div>
                <div className="col-12">
                    <div className="challenge-detail-card">
                        <div className="table-responsive">
                            <table className="table table-striped">
                                <thead>
                                    <tr>
                                        <th scope="col" style={{ width: 60 }}>#</th>
                                        <th scope="col">Wort</th>
                                        <th scope="col" style={{ width: 60 }}></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {words.map((w, index) => (
                                        <tr key={w.id}>
                                            <th scope="row">{index + 1}</th>
                                            <td>{w.word}</td>
                                            <td>
                                                <i className="fa fa-trash" style={{ cursor: 'pointer' }} onClick={() => remove(w.id!)}></i>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default React.memo(Profanity)
